import { fetchWithAuth } from '../apiClient';

/**
 * @typedef {Object} TaskAnalytics
 * @property {string} [healthState]    // e.g., "healthy" | "slipping" | "struggling" | "ignored" | "unknown"
 * @property {number} [healthScore]    // 0–100; higher is healthier
 * @property {number} [completionRate] // 0–1 (ratio of completions to firings in the recent window)
 * @property {number} [firingsCount]
 * @property {number} [completionsCount]
 * @property {number} [daysSinceLastCompletion]
 */

export async function fetchSchedules() {
  const response = await fetchWithAuth('/Scheduler/schedules');
  const data = await response.json();
  // Normalize to the shape used throughout the UI
  return data.map((schedule) => ({
    originJobKey: schedule.originJobKey,
    nextRunTime: schedule.nextRunTime,
    description: schedule.description,
    naturalCronDescription: schedule.naturalCronDescription ?? null,
    createdDate: schedule.createdDate,
    isFiring: !!schedule.isFiring,
    isPaused: !!schedule.isPaused,
    analytics: schedule.analytics ?? null,
  }));
}
